module.exports = __webpack_public_path__ + "img/form-icon.8033282c.svg";